<template>
  <div class="m-auto bg-white text-center py-4">
    <div class="csat my-4">
    </div>
  </div>
</template>
